import type { ReactElement } from "react"

import { Grid } from "@mui/material"

import { DecisionReasonInsight } from "./RealTimeInsights/DecisionReasonsInsight"
import { FeedbackPerLabelsAndReasonsContainer } from "./RealTimeInsights/FeedbackPerLabelsAndReasons"
import { LabelFeedbackInsights } from "./RealTimeInsights/LabelFeedbackInsights"

export function Container(): ReactElement {
  return (
    <Grid container gap={2}>
      <LabelFeedbackInsights />

      <DecisionReasonInsight />

      <FeedbackPerLabelsAndReasonsContainer />
    </Grid>
  )
}
